import { useEffect, useMemo, useState } from 'react';
import transactionsRegistry from 'src/services/transactions/transactions-registry';
import { IRegistryTransaction, ITransactionStatusE } from 'src/services/transactions/types';
import { NFTI } from '@tacans/shared-marketplace-layer';

export const useGetActiveTransactionsByTokenId = (
    token: NFTI,
    status: ITransactionStatusE = ITransactionStatusE.Pending
) => {
    const [
        transactions,
        setTransactions
    ] = useState<IRegistryTransaction[]>([]);

    const activeTransactions = useMemo(() => transactions.filter(
        tr => tr.token.id === token.id && status === tr.status
    ), [transactions, token, status]);

    useEffect(() => {
        const allTransactions = transactionsRegistry.getAll();
        transactionsRegistry.subscribe(setTransactions);
        setTransactions(allTransactions);

        return () => {
            transactionsRegistry.unsubscribe(setTransactions);
        };
    }, []);

    return activeTransactions;
};
